import React from 'react';
import { useLocalstorageState } from 'rooks';

import { getSearchAgentsStorageKey } from '../../../../hooks/useSearchIsSaved/useSearchIsSaved';
import { SavedSearchParams } from '../SavedSearches';

export type SavedSearchContextType = {
  savedSearches: SavedSearchParams[];
  setSavedSearches: React.Dispatch<React.SetStateAction<SavedSearchParams[]>>;
};

export const SavedSearchContext = React.createContext<SavedSearchContextType>({
  savedSearches: [],
  setSavedSearches: () => {
    throw new Error('setSavedSearches function must be overridden');
  },
});

export const SavedSearchProvider: React.FC<{
  initialSavedSearches?: SavedSearchParams[];
  children: React.ReactNode;
}> = ({ children, initialSavedSearches = [] }) => {
  const [savedSearches, setSavedSearches] = useLocalstorageState<SavedSearchParams[]>(
    getSearchAgentsStorageKey(),
    initialSavedSearches
  );
  return (
    <SavedSearchContext.Provider value={{ savedSearches, setSavedSearches }}>{children}</SavedSearchContext.Provider>
  );
};
